/*
 * @Description: 自然人
 * @Date: 2020-10-14 15:58:13
 * @LastEditors: Please set LastEditors
 */

import { accountManagement } from '@/api/ajax';
import fields from '../fields';
import search from '../search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';

let exportOperationLog = {
  name: '导出',
  icon: '',
  type: 'primary',
  async fn(app, table) {
    let {
      isMaster = '',
      optionType = '',
      startTime = '',
      endTime = '',
      subAccountName = ''
    } = table.searchQuery;
    const userId = JSON.parse(localStorage.getItem('user')).id;
    this.$downloadFile(
      `${accountManagement.operationLogExport}?userId=${userId}&isMaster=${isMaster}&optionType=${optionType}&startTime=${startTime}&endTime=${endTime}&subAccountName=${subAccountName}`,
      true
    );
  }
};

let example = new TableRenderClass({ fields, search });
let partA = example.createPart({
  name: '主账号',
  search: ['happendTime', 'optionType', 'logExport'],
  list: accountManagement.operationLogList,
  defaultQuery: { isMaster: 0 },
  fields: ['index', 'logAction', 'happendDt', 'remarks'],
  moreBtnArr: [exportOperationLog]
});

let partB = example.createPart({
  name: '子账号',
  search: ['userName', 'logExport'],
  list: accountManagement.operationLogList,
  defaultQuery: { isMaster: 1 },
  fields: [
    'index',
    'subAccountName',
    'created',
    'lastLoginTime',
    'lastOperationTime',
    'opearte'
  ],
  moreBtnArr: [exportOperationLog]
});

export default [partA, partB];
